import { render, staticRenderFns } from "./InjectionConfig.vue?vue&type=template&id=7f1307d6&scoped=true"
import script from "./InjectionConfig.vue?vue&type=script&lang=js"
export * from "./InjectionConfig.vue?vue&type=script&lang=js"
import style0 from "./InjectionConfig.vue?vue&type=style&index=0&id=7f1307d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1307d6",
  null
  
)

export default component.exports